import {getAssetUrl} from '@Utils/s3.util';

export interface AiChatLoginSectionProps {
  className?: string;
  textClassName?: string;
}

export interface AIChatLoginSectionContent {
  heading1LangKey: string;
  heading2LangKey: string;
  imgURL: string;
}

export const AI_CHAT_LOGIN_SECTION_CONTENT: AIChatLoginSectionContent[] = [
  {
    heading1LangKey: 'pmwjs_create_instant',
    heading2LangKey: 'pmwjs_designs_with_ai',
    imgURL: getAssetUrl('ai-chat-login-page-promo-img-1.webp')
  },
  {
    heading1LangKey: 'pmwjs_brainstorm_ideas_with',
    heading2LangKey: 'pmwjs_ai_for_your_business',
    imgURL: getAssetUrl('ai-chat-login-page-promo-img-2.webp')
  },
  {
    heading1LangKey: 'pmwjs_transform_designs',
    heading2LangKey: 'pmwjs_like_a_pro_with_ai',
    imgURL: getAssetUrl('ai-chat-login-page-promo-img-3.webp')
  }
];